/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDialogEditMemberStatusController', MemberManagementDialogEditMemberStatusController);

    MemberManagementDialogEditMemberStatusController.$inject = ['$uibModalInstance', 'profile', 'MemberManagement', 'AlertService'];

    function MemberManagementDialogEditMemberStatusController ($uibModalInstance, profile, MemberManagement, AlertService) {
        var vm = this;

        vm.member = profile;
        vm.clear = clear;
        vm.setMember = setMember;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function setMember(memberStatus) {
            vm.isSaving = true;
            var copy = angular.copy(profile);
            copy.memberStatus = memberStatus;
            MemberManagement.update(copy,
                function () {
                    AlertService.success("Mitglied " + profile.user.login + " wurde erfolgreich aktualisiert.");
                    $uibModalInstance.close();
                    vm.isSaving = false;
                },
                function (error) {
                    if (error.status === 400 && error.data === 'mail already in use') {
                        AlertService.error("E-Mail ist bereits registriert. Mitglied " + profile.user.login + " kann nicht reaktiviert werden.");
                    }

                    if (error.status === 400 && error.data === 'offene_forderungen') {
                        AlertService.error("Es gibt offene Forderungen. Status kann nicht geändert werden.");
                    }

                    vm.isSaving = false;
                }
            );
        }
    }
})();
